import * as swcHelpers from '@swc/helpers';
import { Types } from '@grandvisionhq/common';
import { getLocalizedString } from '@grandvisionhq/utils';
import { toBaseLineItem } from './base-line-item.js';
import { getPrices } from '../utils/get-prices.js';

function toLens(lens) {
    const { pupillaryDistance , prism , power , cylinder , axis , addition  } = lens;
    return swcHelpers.objectSpread({}, pupillaryDistance ? {
        pupillaryDistance
    } : null, prism ? {
        prism
    } : null, power ? {
        power
    } : null, cylinder ? {
        cylinder
    } : null, axis ? {
        axis
    } : null, addition ? {
        addition
    } : null);
}
function getPrescription(lineItem) {
    if (lineItem.__typename === 'OrderLineItemNonPrescriptionBundle' || !lineItem.prescription) {
        return undefined;
    }
    const { prescription  } = lineItem;
    switch(prescription.__typename){
        case 'AddedGlassesPrescription':
            return {
                type: Types.PrescriptionType.NEW_PRESCRIPTION,
                leftLens: toLens(prescription.leftLens),
                rightLens: toLens(prescription.rightLens)
            };
        case 'FilePrescription':
            return {
                type: Types.PrescriptionType.PRESCRIPTION_FILE,
                /**
         * TODO: YB - need to talk to BE about the FE needing a file name instead of a URL, and for
         * both prescription file and pupillary distance file.
         */ prescriptionFile: prescription.prescriptionFileName,
                pupillaryDistanceFile: prescription.pupillaryDistanceFileName
            };
        case 'EmailPrescription':
            return {
                type: Types.PrescriptionType.EMAIL_PRESCRIPTION
            };
        default:
            return {
                type: Types.PrescriptionType.EXISTING_CUSTOMER
            };
    }
}
const mapBundleChildLineItems = (lineItem, intl)=>{
    return lineItem.configurationDetails.map((child)=>toBundleChildLineItem(intl)(child)
    ).filter((child)=>{
        if (lineItem.__typename === 'OrderLineItemNonPrescriptionBundle') {
            // As per design of the NonPrescriptionBundle on the backend, configurationDetails
            // include other parts of the bundle which are not relevant for the end user
            // the only relevant type for displaying as an addon is configurationbundle type which is why we only leave this in.
            // as per discussion with Surajeet Bhuinya, architect for Team Offical on 30.06.2022
            return child.productType === 'configurationbundle';
        }
        return true;
    });
};
const toBundleChildLineItem = (intl)=>(child)=>({
            productType: child.configurationType,
            name: getLocalizedString(child.description, intl.locale),
            originalPrice: child.productPrice,
            discountedPrice: child.productPrice === child.totalPaid ? undefined : child.totalPaid
        })
;
const toGlassesBundleOrderLineItem = (lineItem, intl, options = {})=>{
    const { lineItemOriginalPrice , lineItemDiscountedPrice  } = getPrices(lineItem);
    const { productPrice , totalPaid  } = lineItem.product;
    return swcHelpers.objectSpread({}, toBaseLineItem(lineItem, intl, options), {
        type: 'GLASSES_BUNDLE',
        prescription: getPrescription(lineItem),
        // lineItemOriginalPrice is the price we show as TOTAL PRICE for the entire bundle, including child line items
        lineItemOriginalPrice,
        // lineItemDiscountedPrice is the price with the discount appled which we show next to the TOTAL PRICE for the entire bundle, including child line items
        lineItemDiscountedPrice,
        // productOriginalPrice is the non-discounted price we show as the price of the main bundle line item, i.e. the main product of the line item
        productOriginalPrice: productPrice,
        // productDiscountedPrice is the discounted price we show as the price of the main bundle line item, i.e. the main product of the line item
        productDiscountedPrice: totalPaid === productPrice ? undefined : productPrice,
        bundleChildLineItems: mapBundleChildLineItems(lineItem, intl)
    });
};

export { toGlassesBundleOrderLineItem };
//# sourceMappingURL=glasses-bundle-line-item.js.map
